// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/confetti.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".purchase-success[data-v-9120180c]{background-position:top;background-size:contain}.purchase-success[data-v-9120180c],.purchase-success-mobile[data-v-9120180c]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.purchase-success-mobile[data-v-9120180c]{background-size:cover;background-repeat:no-repeat}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
